import React from 'react'
import { Button, Dropdown, makeStyles, shorthands, tokens, Option } from '@fluentui/react-components'
import { Checkmark20Filled } from '@fluentui/react-icons'
import { useSearchParams } from 'react-router-dom'
import { Card } from '../common/card/Card'

const useStyles = makeStyles({
   onlyPhone: {
      display: 'none',
      '@media screen and (max-width: 640px)': {
         display: 'block',
         marginBottom: tokens.spacingVerticalM,
      },
   },
   hideInPhone: {
      '@media screen and (max-width: 640px)': {
         display: 'none',
      },
   },
   filterWrapper: {
      display: 'flex',
      flexWrap: 'wrap',
      ...shorthands.gap(tokens.spacingHorizontalS),
   },
   active: {
      backgroundColor: tokens.colorNeutralBackground1Selected,
   },
   completed: {
      color: tokens.colorStatusSuccessForeground1,
      ...shorthands.borderColor(tokens.colorStatusSuccessBorder1),
   },
   completedIcon: {
      color: tokens.colorStatusSuccessForeground1,
   },
   header: {
      '@media screen and (max-width: 1007px)': {
         display: 'flex',
      },
   },
})

type ProcessFilterProps = {
   setProcess: (process: string) => void
   processes: string[]
   completedProcesses?: string[]
   title: string
   action?: JSX.Element
}
export const Processfilter = ({ setProcess, processes, completedProcesses, title, action }: ProcessFilterProps) => {
   const [searchParams] = useSearchParams()
   const selectedProcess = searchParams.get('process')
   const classes = useStyles()
   return (
      <>
         <Card className={classes.hideInPhone} headerClassName={classes.header} title={title} contentClassName={classes.filterWrapper} action={action ?? null}>
            <>
               {processes.length > 2 && // 2 because "All processes" counts as a process here
                  processes.map((x) => {
                     const isCompleted = completedProcesses?.includes(x) ?? false
                     return (
                        <Button
                           key={x}
                           onClick={() => {
                              setProcess(x)
                           }}
                           icon={isCompleted ? <Checkmark20Filled className={classes.completedIcon} /> : undefined}
                           className={`${selectedProcess === x ? classes.active : ''} ${isCompleted ? classes.completed : ''}`}
                        >
                           {x}
                        </Button>
                     )
                  })}
            </>
         </Card>
         <Dropdown
            className={classes.onlyPhone}
            style={{ width: '100%' }}
            value={selectedProcess}
            selectedOptions={[selectedProcess]}
            onOptionSelect={(e, data) => {
               setProcess(data.optionValue)
            }}
         >
            {processes.map((x) => {
               const isCompleted = completedProcesses?.includes(x) ?? false
               return (
                  <Option key={x} text={x}>
                     {isCompleted && <Checkmark20Filled className={classes.completedIcon} />}
                     {x}
                  </Option>
               )
            })}
         </Dropdown>
      </>
   )
}
